<template>
  <section>
    <div class="infoWrap">
      <div class="infoGrid">
        <div class="section-wrapper">
          <h2>学校紹介</h2>
          <p>
            基礎学力の定着・向上を図り、また目の届くクラス編成で児童・生徒一人ひとりの個性や能力に応じた指導を進めます。
            同時に日本語学習を通じて日本文化の体得を目指します。
          </p>
        </div>

        <div class="section-wrapper">
          <h2>授業日</h2>
          <p>
            毎週土曜午前中
            <br />
            (フランスの公立学校の休みの期間を除く)
          </p>
        </div>

        <div class="section-wrapper">
          <h2>対象学年</h2>
          <p>幼稚園部3歳児から高校3年生まで</p>
        </div>

        <div class="section-wrapper">
          <h2>校舎</h2>
          <p>
            当校は、Villeurbanne市のアソシエーション会館や学校校舎等を土曜日の午前中に借用しています。
            詳細は<a href="mailto:lyonhoshuko@adlcj.fr" class="mailLink"
              >こちらよりメールでお問い合わせ</a
            >ください。
          </p>
        </div>

        <div class="section-wrapper">
          <h2>主な学校行事</h2>
          <p>
            学習発表会、授業参観、保護者個人面談など、1年を通じて多彩な行事を設けています。
          </p>
        </div>

        <div class="section-wrapper">
          <h2>図書貸出</h2>
          <p>
            図書コーナーにて幼児から大人向けの日本の本、漫画、ビデオ教材などを貸し出しています。
          </p>
        </div>

        <div class="section-wrapper">
          <h2>入学資格</h2>
          <p>
            日本語での教師の指示が理解でき、かつ日本語での授業が理解できる、3歳以上の日本国籍を有する児童・生徒、
            または両親の少なくともどちらかが日本語を母国語とするご家庭の児童を対象としています。
          </p>
        </div>

        <div class="section-wrapper">
          <h2>補習授業校のクラス編成</h2>
          <p>
            当校では現地校の学年にとらわれることなく、児童・生徒の習熟度に適したクラスに入ることができます。
            少人数クラスでも、必要に応じて、講師のほかにアシスタントを置いて、一人ひとりにきめ細かな指導を心がけています。
          </p>
        </div>

        <div class="section-wrapper">
          <h2>入学時期</h2>
          <p>
            新学期の9月から1年間の登録となります。
            途中入学は幼稚部は9月、1月、4月の学期始めのみ、小学部は随時受け入れております。
            体験入学も受け付けておりますので、ご希望の方は<a
              href="mailto:lyonhoshuko@adlcj.fr"
              class="mailLink"
              >こちらよりお問い合わせ</a
            >ください。
          </p>
        </div>

        <div class="section-wrapper">
          <h2>ボランティアアシスタント募集中</h2>
          <p>
            リヨン補習授業校では、授業のサポートをして下さるボランティアアシスタントを募集しています。
            詳細は下記をご参照ください。
          </p>

          <ButtonSecondary
            label="アシスタント募集要項"
            variant="grey"
            to="/recrutement"
          />
        </div>

        <div class="section-wrapper">
          <h2>補習授業校の運営組織</h2>
          <p>
            当校は、ADLCJ日本語・日本文化振興協会の運営委員会によって運営されています。
          </p>

          <p>
            当サイトでは、子供たちの安全を最優先に考慮し、所在地やスケジュールの詳細を一般公開しておりません。
            詳しい情報をご希望の方は、どうぞ遠慮なく<a
              href="mailto:lyonhoshuko@adlcj.fr"
              class="mailLink"
              >お問い合わせ</a
            >ください。
          </p>

          <p>リヨン補習授業校 ADLCJ</p>

          <p>
            <a
              href="https://www.facebook.com/Adlcjlyonhoshujyugyoko/"
              class="facebookLink"
              target="_blank"
              rel="noopener noreferrer"
            >
              補習校Facebookページはこちら
            </a>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ButtonSecondary from "./ButtonSecondary.vue";

export default {
  name: "EcoleJA",
  components: { ButtonSecondary },
};
</script>

<style lang="scss" scoped>
.infoWrap {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 0 60px;
  text-align: left;
}

.infoGrid {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.section-wrapper h2 {
  border: none;
  background-image: none;
  padding: 0;
  font-size: 1.25rem;

  @media (max-width: 767px) {
    font-size: 1rem;
  }
}

.section-wrapper p {
  font-size: 20px;

  @media (max-width: 767px) {
    font-size: 0.85rem;
  }
}
.section-wrapper p a {
  color: $linkColor;
  text-decoration: none;
  font-weight: 600;
  &:hover {
    text-decoration: underline;
  }
}

.facebookLink {
  display: inline-block;
  margin-top: 0.5rem;
  font-weight: 600;
  color: $linkColor;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}
</style>
